import ReferralQuestionnairePage from './ReferralQuestionnairePage';

export default ReferralQuestionnairePage;
